import React, { useState } from 'react';

const CheckoutCollapse = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="collapse-block">
      <div
        className={`collapse-block__header ${
          isOpen ? 'collapse-block__header-open' : ''
        }`}
        onClick={(_) => setIsOpen(!isOpen)}
      >
        {title}
      </div>
      <div
        className={`collapse-block__content ${
          isOpen ? 'collapse-block__content-open' : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default CheckoutCollapse;
